import R from 'ramda';
import getSubcategories from './get-subcategories';

export const getFilters = ({ selectedFilters = [], categories = [] }) => {
  // if no options for a category are selected then the filter should
  // behave as if all options are selected so we add them as additonal filters
  const additionalFilters = R.compose(
    R.flatten,
    R.map(({ name, options = [] }) => {
      const categoryHasFilter = !!selectedFilters.find(({ categoryName }) => categoryName === name);

      return categoryHasFilter ? [] : (
        options.map(({ name: optionName }) => ({
          categoryName: name,
          optionName,
        }))
      );
    }),
  )(categories);

  return [...selectedFilters, ...additionalFilters];
};

export const isProductMatchedByFilters = ({
  selectedFilters = [],
  categories = [],
  productCategories = [],
}) => {
  const filters = R.isEmpty(selectedFilters) ? getFilters({ selectedFilters, categories }) : selectedFilters;

  return R.compose(
    R.any(item => item),
    R.map((values) => {
      if (!R.isEmpty(selectedFilters)) {
        return !!filters.find(({ optionName }) => !!values.find(({ name }) => name === optionName));
      }

      return true;
    }),
    R.map(({ name }) => getSubcategories({
      categories: productCategories,
      categoryName: name,
    })),
  )(categories);
};

export default ({
  products = [],
  selectedFilters = [],
  categories = [],
}) => (
  products.filter(({ filterCategories: productCategories }) => (
    isProductMatchedByFilters({ selectedFilters, categories, productCategories })
  ))
);
